import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bulkLockAgentsBettingRules } from "@/api/agents";
import { AgentsQueryKeys } from "@/tanstackQuery/queries/agents/agentQueryKeys";

export const useBulkLockAgentsBettingRules = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: bulkLockAgentsBettingRules,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [AgentsQueryKeys.All],
      });
    },
  });
};
